import AxiosClient from "../../../services/axios.services";

class VacationRequestServices {
  getRequestsByEmployee = (empleadoId) =>
    AxiosClient.get(`/api/app/solicitudes-vacaciones/?empleado=${empleadoId}`);

  getRequest = (id) =>
    AxiosClient.get(`/api/app/solicitudes-vacaciones/${id}`);

  createRequest = (data) =>
    AxiosClient.post("/api/app/solicitudes-vacaciones/", data);

  updateRequest = (id, data) =>
    AxiosClient.put(`/api/app/solicitudes-vacaciones/${id}/`, data);

  deleteRequest = (id) =>
    AxiosClient.delete(`/api/app/solicitudes-vacaciones/${id}/`);
}

export default new VacationRequestServices();